import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
  ApolloLink,
  ApolloProvider,
  gql,
  concat,
} from "@apollo/client";

const httpLink = new HttpLink({
  uri: "https://m3kihfsnnjhwdluhyhl5yajzve.appsync-api.ap-south-1.amazonaws.com/graphql", 
});

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      "x-api-key": "da2-2d44ydbj4jbmxj4lae5xrnko7q",
    },
  }));

  return forward(operation);
});

const without_token_client = new ApolloClient({
  cache: new InMemoryCache(),
  link: concat(authMiddleware, httpLink),
});

export default without_token_client;
